module.exports = __webpack_public_path__ + "img/tumbir.sh.8a000ff4.svg";